export default "__VITE_ASSET__BMWVFItW__"